// List Constants
export const BUSINESS_ORGANISATION_LIST_REQUEST = 'BUSINESS_ORGANISATION_LIST_REQUEST';
export const BUSINESS_ORGANISATION_LIST_SUCCESS = 'BUSINESS_ORGANISATION_LIST_SUCCESS';
export const BUSINESS_ORGANISATION_LIST_FAIL = 'BUSINESS_ORGANISATION_LIST_FAIL';

// Details Constants
export const BUSINESS_ORGANISATION_DETAILS_REQUEST = 'BUSINESS_ORGANISATION_DETAILS_REQUEST';
export const BUSINESS_ORGANISATION_DETAILS_SUCCESS = 'BUSINESS_ORGANISATION_DETAILS_SUCCESS';
export const BUSINESS_ORGANISATION_DETAILS_FAIL = 'BUSINESS_ORGANISATION_DETAILS_FAIL';
export const BUSINESS_ORGANISATION_DETAILS_RESET = 'BUSINESS_ORGANISATION_DETAILS_RESET';

// Create Constants
export const BUSINESS_ORGANISATION_CREATE_REQUEST = 'BUSINESS_ORGANISATION_CREATE_REQUEST';
export const BUSINESS_ORGANISATION_CREATE_SUCCESS = 'BUSINESS_ORGANISATION_CREATE_SUCCESS';
export const BUSINESS_ORGANISATION_CREATE_FAIL = 'BUSINESS_ORGANISATION_CREATE_FAIL';
export const BUSINESS_ORGANISATION_CREATE_RESET = 'BUSINESS_ORGANISATION_CREATE_RESET';

// Update Constants
export const BUSINESS_ORGANISATION_UPDATE_REQUEST = 'BUSINESS_ORGANISATION_UPDATE_REQUEST';
export const BUSINESS_ORGANISATION_UPDATE_SUCCESS = 'BUSINESS_ORGANISATION_UPDATE_SUCCESS';
export const BUSINESS_ORGANISATION_UPDATE_FAIL = 'BUSINESS_ORGANISATION_UPDATE_FAIL';
export const BUSINESS_ORGANISATION_UPDATE_RESET = 'BUSINESS_ORGANISATION_UPDATE_RESET';

// Delete Constants
export const BUSINESS_ORGANISATION_DELETE_REQUEST = 'BUSINESS_ORGANISATION_DELETE_REQUEST';
export const BUSINESS_ORGANISATION_DELETE_SUCCESS = 'BUSINESS_ORGANISATION_DELETE_SUCCESS';
export const BUSINESS_ORGANISATION_DELETE_FAIL = 'BUSINESS_ORGANISATION_DELETE_FAIL';

// DTO Constants
export const BUSINESS_ORGANISATION_DTO_REQUEST = 'BUSINESS_ORGANISATION_DTO_REQUEST';
export const BUSINESS_ORGANISATION_DTO_SUCCESS = 'BUSINESS_ORGANISATION_DTO_SUCCESS';
export const BUSINESS_ORGANISATION_DTO_FAIL = 'BUSINESS_ORGANISATION_DTO_FAIL';
export const BUSINESS_ORGANISATION_DTO_RESET = 'BUSINESS_ORGANISATION_DTO_RESET';

// List By IDs Constants
export const BUSINESS_ORGANISATION_LIST_BYIDS_REQUEST = 'BUSINESS_ORGANISATION_LIST_BYIDS_REQUEST';
export const BUSINESS_ORGANISATION_LIST_BYIDS_SUCCESS = 'BUSINESS_ORGANISATION_LIST_BYIDS_SUCCESS';
export const BUSINESS_ORGANISATION_LIST_BYIDS_FAIL = 'BUSINESS_ORGANISATION_LIST_BYIDS_FAIL';
export const BUSINESS_ORGANISATION_LIST_BYIDS_RESET = 'BUSINESS_ORGANISATION_LIST_BYIDS_RESET';

// Activate Constants
export const BUSINESS_ORGANISATION_ACTIVATE_REQUEST = 'BUSINESS_ORGANISATION_ACTIVATE_REQUEST';
export const BUSINESS_ORGANISATION_ACTIVATE_SUCCESS = 'BUSINESS_ORGANISATION_ACTIVATE_SUCCESS';
export const BUSINESS_ORGANISATION_ACTIVATE_FAIL = 'BUSINESS_ORGANISATION_ACTIVATE_FAIL';
export const BUSINESS_ORGANISATION_ACTIVATE_RESET = 'BUSINESS_ORGANISATION_ACTIVATE_RESET';

// Deactivate Constants
export const BUSINESS_ORGANISATION_DEACTIVATE_REQUEST = 'BUSINESS_ORGANISATION_DEACTIVATE_REQUEST';
export const BUSINESS_ORGANISATION_DEACTIVATE_SUCCESS = 'BUSINESS_ORGANISATION_DEACTIVATE_SUCCESS';
export const BUSINESS_ORGANISATION_DEACTIVATE_FAIL = 'BUSINESS_ORGANISATION_DEACTIVATE_FAIL';
export const BUSINESS_ORGANISATION_DEACTIVATE_RESET = 'BUSINESS_ORGANISATION_DEACTIVATE_RESET';

// Agreement Update Constants
export const BUSINESS_ORGANISATION_AGREEMENT_UPDATE_REQUEST = 'BUSINESS_ORGANISATION_AGREEMENT_UPDATE_REQUEST';
export const BUSINESS_ORGANISATION_AGREEMENT_UPDATE_SUCCESS = 'BUSINESS_ORGANISATION_AGREEMENT_UPDATE_SUCCESS';
export const BUSINESS_ORGANISATION_AGREEMENT_UPDATE_FAIL = 'BUSINESS_ORGANISATION_AGREEMENT_UPDATE_FAIL';
export const BUSINESS_ORGANISATION_AGREEMENT_UPDATE_RESET = 'BUSINESS_ORGANISATION_AGREEMENT_UPDATE_RESET';

// Email Constants
export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';
export const SEND_EMAIL_RESET = 'SEND_EMAIL_RESET'; 